import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateBuildCrosswordComponent } from './components/build-crossword/util/can.deactivate.build.crossword.component';
import { CanDeactivatePlayCrosswordComponent } from './components/gameplay/play-crossword/play-crossword-guard.component';
import { RoutingService } from './services/routing-service/routing.service';

const routes: Routes = RoutingService.getAppRoutes();

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [CanDeactivatePlayCrosswordComponent, CanDeactivateBuildCrosswordComponent],
})
export class AppRoutingModule {}
